<template>
  <div>
    <div class="iframe" v-if="video.streamer === 'STAMPYT'">
      <video controls width="250">
        <source :src="video.url" type="video/mp4" />
        Sorry, your browser doesn't support embedded videos.
      </video>
    </div>

    <!-- NO RESULT -->
    <div v-else-if="video.reference === ''" class="no-result">{{ $t('shooting.noVideo') }}</div>

    <div v-else>
      <!-- YOUTUBE -->
      <div class="video-container" v-if="video.streamer === 'YOUTUBE'">
        <iframe
          title="youtube video player"
          width="100%"
          height="100%"
          :src="youtubeUrl"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>

      <!-- CLOUDFLARE -->
      <div v-else-if="video.streamer === 'CLOUDFLARE'">
        <div style="position: relative; padding-top: 56.25%">
          <iframe
            :src="cloudflareUrl"
            style="border: none; position: absolute; top: 0; height: 100%; width: 100%"
            allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
            allowfullscreen="true"
          ></iframe>
        </div>
      </div>

      <!-- ERROR -->
      <div v-else>
        <p class="no-result">{{ $t('shooting.badVideoFormat') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { createYoutubeUrl } from '@/script/utils.js'

export default {
  name: 'VideoPlayer',

  props: {
    video: Object
  },

  computed: {
    cloudflareUrl() {
      return `https://iframe.videodelivery.net/${this.video.reference}`
    },
    youtubeUrl() {
      return createYoutubeUrl(this.video.reference)
    }
  }
}
</script>

<style lang="sass" scoped>
.video-container
  position: relative
  margin: 20px 0
  padding-bottom: 56.25%

iframe
  position: absolute
  top: 0
  left: 0
  width: 100%
  height: 100%

.no-result
  font-size: 22px
  text-align: center
  margin: 25px 0
</style>
